<template>
  <my-container section>
    <main-title center wave>{{ nowCourse ? nowCourse.name : "" }}</main-title>
    <main-text
      center
      v-html="nowCourse ? nowCourse.description : ''"
    ></main-text>
    <div v-for="day in formattedSchedule" :key="day.id">
      <second-title center wave>{{ day ? day.name : "" }}</second-title>
      <div v-if="day.items.length" class="py-2">
        <v-divider />
        <div v-for="lesson in day.items" :key="lesson.id">
          <v-row class="flex-column-reverse flex-md-row">
            <v-col cols="12" md="2" class="text-center text-md-right">
              <main-text>
                <span v-if="lesson.time_start && lesson.time_end">
                  {{ lesson.time_start }} - {{ lesson.time_end }}
                </span>
                <span v-else>
                  {{ nowCourse.time_start }} - {{ nowCourse.time_end }}
                </span>
              </main-text>
              <second-text class="grey--text">
                ауд. {{ lesson.cabinet ? lesson.cabinet.name : "" }}
              </second-text>
            </v-col>
            <v-col
              cols="12"
              md="2"
              :class="{ 'd-none d-md-block': !howOften[lesson.how_often] }"
            >
              <main-text class="d-flex align-center justify-center fill-height">
                {{ howOften[lesson.how_often] }}
              </main-text>
            </v-col>
            <v-col cols="12" md="8" class="text-center text-md-left">
              <main-text>{{
                lesson.subject ? lesson.subject.name : ""
              }}</main-text>
              <second-text class="grey--text">{{
                formatTeacher(lesson.teacher)
              }}</second-text>
            </v-col>
          </v-row>
          <v-divider class="pb-6" />
        </div>
      </div>
      <second-text center class="grey--text py-2" v-else>
        <v-divider />
        <v-col cols="12">Занятий нет</v-col>
        <v-divider class="pb-6" />
      </second-text>
    </div>
  </my-container>
</template>

<script>
import API from "@/common/api/api.functions";
import { mapGetters } from "vuex";
import MainTitle from "@/components/MainTitle";
import MyContainer from "@/components/MyContainer";
import SecondTitle from "@/components/SecondTitle";
import MainText from "@/components/MainText";
import SecondText from "@/components/SecondText";

export default {
  name: "Schedule",
  components: { SecondText, MainText, SecondTitle, MyContainer, MainTitle },
  data: () => ({
    schedule: [],
    defaultSchedule: [
      "Понедельник",
      "Вторник",
      "Среда",
      "Четверг",
      "Пятница",
      "Суббота",
      "Воскресение"
    ],
    howOften: {
      all: "",
      numerator: "числитель",
      denominator: "знаменатель"
    }
  }),
  computed: {
    ...mapGetters(["courses"]),
    courseID() {
      return parseInt(this.$route.params.id) || null;
    },
    nowCourse() {
      return this.courses.find(el => el.id === parseInt(this.courseID));
    },
    formattedSchedule() {
      return this.defaultSchedule.map((el, key) => {
        return {
          name: el,
          items: this.schedule.filter(el => el.day === key)
        };
      });
    }
  },
  methods: {
    async getData() {
      this.schedule = await API.getLessons({ course: this.courseID }).then(
        response => response.data
      );
    },
    formatTeacher(teacher) {
      let name = [teacher.last_name, `${teacher.first_name[0]}.`];
      if (teacher.middle_name) name = [...name, `${teacher.middle_name[0]}.`];
      return name ? name.join(" ") : "";
    }
  },
  created() {
    this.getData();
  },
  watch: {
    courseID() {
      this.getData();
    }
  }
};
</script>
